import {dataHooks} from '@wix/data-hooks'

export const experiencesListDataHooks = dataHooks<{
  root: {}
}>('experiences-list')
